import * as React from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';

import { IModalSuggestionsProps } from '../Suggestion.types';
import { SuggestionList } from '../SuggestionList';
import { Footer } from '../footer/Footer';
import {
  MODAL_SEARCH_SUGGESTIONS_TEST_ID,
  MODAL_SEARCH_SUGGESTIONS_CLOSE_BUTTON_TEST_ID,
} from '../../constants';

import { ReactComponent as ArrowRightSymbolSvg } from '../../assets/ArrowRight.svg';
import { Loader } from './Loader';
import style from './ModalSuggestions.scss';

export const ModalSuggestions: React.FC<IModalSuggestionsProps> = props => {
  const {
    children,
    closeSuggestions,
    direction,
    imageResizeMode,
    onClear,
    onScroll,
    onSuggestionsFooterClick,
    query,
    scrollIntoRef,
    suggestions,
    suggestionsLoading,
    translate,
  } = props;

  const onClickCloseSuggestions = () => {
    closeSuggestions();
    onClear();
  };

  const [modalWrapper, setModalWrapper] = React.useState<Element>();

  React.useEffect(() => {
    const modalWrapperElement = document.createElement('div');
    document.body.appendChild(modalWrapperElement);

    setModalWrapper(modalWrapperElement);

    return () => {
      document.body.removeChild(modalWrapperElement);
    };
  }, []);

  return modalWrapper
    ? createPortal(
        <div
          dir={direction}
          className={style.root}
          data-testid={MODAL_SEARCH_SUGGESTIONS_TEST_ID}
          role="dialog"
        >
          <div className={style.searchBoxInputContainer}>
            <div
              className={style.closeButtonContainer}
              data-testid={MODAL_SEARCH_SUGGESTIONS_CLOSE_BUTTON_TEST_ID}
              onClick={onClickCloseSuggestions}
            >
              <ArrowRightSymbolSvg
                className={classNames(style.closeButton, {
                  [style.flipped]: direction === 'rtl',
                })}
              />
            </div>
            <div className={style.searchBoxBorderContainer}>{children}</div>
          </div>
          <div className={style.suggestionContainer} onScroll={onScroll}>
            <SuggestionList
              imageResizeMode={imageResizeMode}
              scrollIntoRef={scrollIntoRef}
              suggestions={suggestions}
              translate={translate}
            />
            {suggestions?.footer && (
              <Footer
                onSuggestionsFooterClick={onSuggestionsFooterClick}
                query={query}
                translate={translate}
              />
            )}
            {suggestionsLoading && <Loader />}
          </div>
        </div>,
        modalWrapper,
      )
    : null;
};
